var map = {
	"./music-instructions.json": 4803,
	"./music-library-intro2024.json": 4804,
	"./music-library-launch2024.json": 4805,
	"./music-progression.json": 4806,
	"./startSourcesAdvanced.json": 4807,
	"./startSourcesSimple.json": 4808,
	"./startSourcesSimple2.json": 4809,
	"./startSourcesTracks.json": 4810
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4515;